import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import { IconButton } from '@components/icon-button';
import { IconSearch } from '@components/icons/search';

import { SearchBox } from 'components/SearchBox';

export const SearchButton = observer((props) => {
  const { onOpen, ...rest } = props;
  return (
    <SearchContainer>
      {props.isOpen && <SearchBox {...rest} />}
      <IconButton onClick={onOpen} icon={<IconSearch />} />
    </SearchContainer>
  );
});

const SearchContainer = styled.div((p) => ({
  marginLeft: p.theme.spacing.m32,
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
  maxWidth: '20rem',
}));
